var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape4Footer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 100,
    viewBox: "0 0 1302 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_402)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_135_402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C235.083 82 488.25 10 723.333 52C922.25 82 1121.17 18 1302 44V100H0V25Z",
    fill: "#4A3828",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 52C180.833 24 415.917 82 651 56C886.083 30 1103.08 78 1302 60V100H0V52Z",
    fill: "url(#paint0_linear_135_402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 68.0001C253.167 50.0001 506.333 86.0001 759.5 68.0001C976.5 50.0001 1175.42 80.0001 1302 70.0001V100H0V68.0001Z",
    fill: "#4A3828"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_402",
    x1: 0,
    y1: 44.1577,
    x2: 0,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3828",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3828"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_135_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4Footer);
export default __webpack_public_path__ + "static/media/Shape 4 Footer.dab46aae0be07f1d01766b79a09fc20d.svg";
export { ForwardRef as ReactComponent };